import React, { Component } from 'react'
import {connect} from 'react-redux';
import cs from 'classnames';
import mapDispatch from '~/misc/mapDispatch';
import { modalChange} from '~/modules/modal/actions';
import MessageList from './compontents/MessageList';
import MessagePanel from './compontents/MessagePanel';
import * as modes from '~/modules/modal/modes';
import {push as changeURL} from 'react-router-redux';
import css from './index.css'

import { 
  getCatalogs, 
  deleteCatalogs, 
  readCatalogs, 
  readAllCatalogs, 
  deleteAllCatalogs, 
  getMessage,
  deleteMessage,
  selectCatalogs,
  resetMessage
} from './state/action'

class MessagePush extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowDelete: false
    }
  }

  componentDidMount() {
    const { getCatalogs } = this.props;
    getCatalogs();
  }
  componentWillUnmount() {
    const { selectCatalogs } = this.props;
    selectCatalogs();
  }

  showDeletePopup = () => {
    this.setState({
      isShowDelete: true
    },() => setTimeout(()=> {
      this.setState({
        isShowDelete: false
      })
    }, 3000))
  }

  select = (type) => {
    const { getMessage, readCatalogs,selectCatalogs } = this.props;
    selectCatalogs(type);
    readCatalogs(type);
    getMessage({type});
  }
  deleteAll = () => {
    const {deleteAllCatalogs} = this.props;
    deleteAllCatalogs().then(this.showDeletePopup)
  }
  
  readAll = () => {
    const {readAllCatalogs} = this.props;
    readAllCatalogs()
  }
  deleteCatalogs = (mainType) => {
    const {deleteCatalogs} = this.props;
    deleteCatalogs(mainType).then(this.showDeletePopup)
  }
  deleteMessage = (msgId, mainType) => { 
    const { deleteMessage } = this.props;
    deleteMessage({msgId, type:mainType }).then(this.showDeletePopup)
  }
  render() {
    const { catalogs, activeCatalog } = this.props;
    const { isShowDelete } = this.state;
    const activeCatalogDetail = catalogs.find(c=>c.mainType === activeCatalog)
    const activeCatalogTilte = activeCatalogDetail ? activeCatalogDetail.name : "Message"
    return (
      <div className={css.warp}>
        <div className={css.messageBox} id="messagePushBoxRef"> 
          <div className={css.messageList}>
            <MessageList
              readAll={this.readAll}
              deleteAll={this.deleteAll}
              select={this.select}
              deleteMessage={this.deleteCatalogs}
              messages={catalogs}
              active={activeCatalog}
            />
          </div>
          <div className={css.messagePanel}>
            <MessagePanel
              type={activeCatalog}
              title={activeCatalogTilte}
              deleteMessage = {this.deleteMessage}
              messages={this.props.messagePush[activeCatalog]}
              showRC={this.props.showSuccess}
              goto={this.props.goto}
            />
          </div>
        </div>
        {
          isShowDelete && <div className={css.deletePopup}>Deleted successfully</div>
        }
      </div>
    )
  } 
}

export default connect(({messagePush}) => ({
  catalogs: messagePush.catalogs,
  activeCatalog: messagePush.activeCatalog,
  messagePush,
}), mapDispatch({
  getCatalogs: () => getCatalogs(),
  deleteCatalogs:  (props, mainType)  => deleteCatalogs(mainType),
  readCatalogs:  (props, mainType)  => readCatalogs(mainType),
  readAllCatalogs: ()=> readAllCatalogs(),
  deleteAllCatalogs: ()=>deleteAllCatalogs(),
  getMessage: (props, {type, msgId})  => getMessage({type, msgId}),
  deleteMessage: (props, {msgId, type})  => deleteMessage({msgId, type}),
  showSuccess: (props, urls)  => modalChange(modes.BOOKRC_VIEW, {type: 'askPop', urls}),
  goto: (props, urls) => changeURL(urls),
  selectCatalogs: (props, catalog) => selectCatalogs(catalog),
  resetMessage: () => resetMessage(),
}))(MessagePush);



// WEBPACK FOOTER //
// ./src/pages/MessagePush/index.js